import * as React from 'react';
import classnames from 'classnames';

import InfluencerDetailsModal from 'modules/organizations/components/settings/influencer/influencer-details-modal/InfluencerDetailsModal';
import { withModal } from 'components/modal/ModalHOC';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { isAccepted } from 'utils/subcampaign';

import type { SidePanelItem } from 'types';

type Props = {
  item: SidePanelItem
}

const DivWithModal = withModal(<span />, {
  modalContent: InfluencerDetailsModal
});

class SidePanelItemInfluencerDetails extends React.Component<Props> {
  render() {
    const { item } = this.props;

    if (!item.meta || !item.meta.subcampaign) {
      return null;
    }

    if (isAccepted(item.meta.subcampaign)) {
      const isBusinessDetailsMissing = !item.meta.subcampaign?.businessDetails?.registeredBusiness &&
        item.type === 'business_details';
      const isBankDetailsMissing = !item.meta.subcampaign?.bankDetails?.accountNumber &&
        item.type === 'bank_details';

      const containerClasses = classnames('context-menu-item__text', {
        'context-menu-item__text--with-icon': isBusinessDetailsMissing || isBankDetailsMissing
      });

      return (
        <DivWithModal
          modalContentProps={{
            subcampaign: item.meta.subcampaign,
            type: item.type
          }}
        >
          <div className={containerClasses}>
            {item.text}
            {
              (isBusinessDetailsMissing || isBankDetailsMissing) && (
              <div className="context-menu-item__icon-container">
                <SVGDynamicIcon
                  name="exclamation-inside-circle-custom-bg"
                  width={16}
                  height={16}
                  customColor="red"
                />
              </div>
              )
            }
          </div>
        </DivWithModal>
      );
    }

    return null;
  }
}

export default SidePanelItemInfluencerDetails;
